import { render } from "./UserLogoutIcon.vue?vue&type=template&id=ccfc1cfc&scoped=true"
import script from "./UserLogoutIcon.vue?vue&type=script&lang=js"
export * from "./UserLogoutIcon.vue?vue&type=script&lang=js"

import "./UserLogoutIcon.vue?vue&type=style&index=0&id=ccfc1cfc&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccfc1cfc"]])

export default __exports__